import { Component } from '@angular/core';

@Component({
  selector: 'app-create-card',
  templateUrl: './create-card.component.html',
  styleUrls: ['./create-card.component.scss']
})
export class CreateCardComponent {
  templates = Array.from({ length: 23 }, (_, i) => i + 1);
  steps = ['Template', 'Info', 'Picture', 'Social', 'Confirm'];

  slickCarouselConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    autoplay: true,
    nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 992,  settings: { slidesToShow: 2 } },
      { breakpoint: 768,  settings: { slidesToShow: 2, dots: false } },
      { breakpoint: 576,  settings: { slidesToShow: 1, dots: false } }
    ]
  };
}